import React from 'react';
import nt_main from '../img/nt_main.jpg';
const MissionAndValues = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">  
            <div>
                My mission is simple<br /><br /><b>to create a space for clients to become aware of the patterns
                    shaping their behavior, choices and lives, so life can feel more aligned than it does now.
                </b><br/><br />
                This is achieved by adhereing to a set of principle
                values that guide my work and interactions:
            </div>
            <div>
                <b>CONFIDENTIALITY</b>, I provide a safe, non-judgmental 
                environments where confidentiality is paramount and your privacy is respected.
            </div>
            <div>
                <b>CLARITY</b>  my superpower is  guide you to see the underlying drivers of 
                behaviour with precision and honesty.
            </div>
            <div>
                <b>DEPTH</b> going beyond traditional methods to address core behavioural patterns.
            </div>
            <div>
                <b>SUSTAINABILITY</b> taking your individual circumstances into account in order to
                ensure measured pace of change to suit your personality type and goals.
            </div>

            </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
            <div>
               в разработке
            </div>
            </div>
        );
    }
}
export default MissionAndValues;
